import React, { useState } from 'react';
import { array, func, object, number } from 'prop-types';
import useWindowWidth from '../custom-hooks/useWindowWidth';

import FilteringDesktop from './FilteringDesktop';
import FilteringMobile from './FilteringMobile';
import MapIcon from './MapIcon';
import Search from './Search';
import SeeAllHotels from './SeeAllHotels';
import { autocomplete } from '../autocomplete';
import { AppContext } from '../AppContext';

function PanelHotels({ allPlaces, theme, hotelsLen, countriesLen }) {
  const [filtered, setFiltered] = useState(allPlaces);
  const [SearchKey, setSearchKey] = useState("");
  const [hidePlaceholder, setHidePlaceholder] = useState(false);
  const [hideDropdown, setHideDropdown] = useState(true);
  const [tagFilter, setTagFilter] = useState([]);
  const [mobileFilter, setMobileFilter] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [isAllShown, setIsAllShown] = useState(false);
  const windowWidth = useWindowWidth();

  function scrollTop() {
    document.getElementById('find-a-hotel-tabs').scrollIntoView({
      block: 'end',
      inline: 'nearest'
    });
  }

  function selectLocation(selection) {
    $('#hotel-search-modal').val(selection);
    $('#reservations-console-modal').trigger('submit');
  }

  function selectKeyword(value) {
    $('#hotel-search-modal').val(value);
    $('#reservations-console-modal').trigger('submit');
  }

  function buildMobileFilterData(selection) {
    setMobileFilter(selection[0].concat(selection[1]));
  }
  
  function inputChange(e) {
    const inputLength = e.target.value.length;
    setSearchKey(e.target.value)
    const selection = autocomplete({
      element: e.target,
      allPlaces
    });

    setInputValue(e.target.value);

    if (inputLength === 0) {
      setFiltered(allPlaces);
      setHidePlaceholder(false);
    } else if (inputLength < 3) {
      setHideDropdown(true);
      setHidePlaceholder(true);
    } else if (inputLength >= 3 && (selection[0].length > 0
      || selection[1].length > 0)) {
      setFiltered(selection[0]);
      setIsAllShown(false);
      setHideDropdown(false);
      setTagFilter(selection[1]);
      buildMobileFilterData(selection);
    }
  }

  function onKeyDown(e) {
    if (!e.key === 'Backspace') {
      setHidePlaceholder(true);
    }
    if(e.key === 'Enter' && e.target.value.length > 3) {
      let findHotelToNavigate = function(hotelList) {
       let hotelFilterArray = [...hotelList];
       if(hotelFilterArray && hotelFilterArray.length > 0) {
       let hotelToTrigger = hotelFilterArray.find((hotel) => {
          let hotelName = $(hotel).children()[0].innerText;
          return hotelName.toLowerCase() === inputValue.toLowerCase();
        })
        if(hotelToTrigger && hotelToTrigger.length!== 0) {
          $(hotelToTrigger).trigger('click');
        }
       }
       return;
      }
      if(windowWidth <= 1024 ) {
        findHotelToNavigate($('.autocomplete-suggestions .autocomplete-block > button.autocomplete-suggestion.suggestion'));
      } else {
        findHotelToNavigate($('.filtered-hotels .find-a-hotel-suggestions > button.find-a-hotel-suggestion.suggestion'));
      }
   }
  }

  function seeAllHotels() {
    setFiltered(allPlaces);
    setHidePlaceholder(false);
    setIsAllShown(true);
    scrollTop();
    setInputValue('');
  }

  function clearInput(){
    setInputValue('');
    setFiltered(allPlaces);
  }

  function onClick(e) {
    let elValue;
    if(e.target.classList.contains('keywords')) {
      selectKeyword($(e.target).attr("data-value"));
      return;
    }
    if (e.target.classList.contains('suggestion')) {
      (e.target.getAttribute('data-value')) ? elValue = e.target.getAttribute('data-value')
      :  elValue = e.target.querySelector('span').textContent;
    } else {
      (e.target.parentNode.getAttribute('data-value')) ? elValue = e.target.parentNode.getAttribute('data-value')
      : elValue = e.target.parentNode.querySelector('span').textContent
    }
    //const selection = allPlaces.filter(item => item.value === elValue);
    selectLocation(elValue && elValue.trim());
  }

  function showMapView() {
    scrollTop();

    // #panel-destination-label is outside of React
    document.getElementById('panel-destination-label').click();
  }

  // This Label is Removed for WCAG Fix
  //<label htmlFor="find-a-hotel">
  //<span className="show-for-sr">Search for a Hotel</span>
  //</label>
  return (
    <AppContext.Provider value={{ onClick, theme }}>
      <div className="tabs-panel tabs-search is-active" id="panel-hotels">
        <div className="grid-x align-center autocomplete-wrap">
          <div className="cell small-9 large-8 find-a-hotel-autocomplete">
            <div className="find-a-hotel-auto-container">
              
              <input
                onChange={inputChange}
                onKeyDown={onKeyDown}
                value={inputValue}
                placeholder={windowWidth > 768 ? 'Where are you going?' : ''}
                autoComplete="off"
                type="text"
                id="find-a-hotel 123"
                className="find-a-hotel"
                name="find-a-hotel"
                aria-label="find-a-hotel"
              />
              <button
              onClick={clearInput}
              className={
                hidePlaceholder ? 'clear-filter' : '' + 'clear-filter hidden'
              }
              >clearInput</button>
              <span
                className={
                  hidePlaceholder ? 'hidden ' : '' + 'placeholder-text'
                }
              >
                <p className="placeholder-primary">Where are you going?</p>
                <p className="placeholder-secondary">
                  Enter a city, state, hotel name or landmark
                </p>
              </span>              
            </div>
            <button
              onClick={seeAllHotels}
              // tabIndex="0"
              aria-label="Show all hotels"
              className="find-a-hotel-large-side show-for-large"
            >
              <p className="text-primary">{hotelsLen} Historic hotels</p>
              <p className="text-secondary">in {countriesLen} countries</p>
              <p className="text-third">See all hotels</p>
            </button>
          </div>
          <div className="cell small-8 find-a-hotel-autocomplete filter-mobile-wrap">
            {!hideDropdown &&
              !isAllShown &&
              allPlaces.length !== filtered.length &&
              windowWidth <= 1024 && (
                <FilteringMobile
                  filtered={mobileFilter}
                  seeAllHotels={seeAllHotels}
                  setHideDropdown={setHideDropdown}
                  searchKey={SearchKey}
                  allPlaces={allPlaces}
                />
              )}
          </div>
          <button
            onClick={showMapView}
            tabIndex="0"
            aria-label="Show map view"
            className="cell show-for-large large-2 autocomplete-secondary"
          >
            {theme && <MapIcon alt={theme.alt} src={theme.src} />}
            <p>Map View</p>
          </button>
        </div>
        <div className="grid-x align-center find-a-hotel-sub-nav hide-for-large">
          <div className="cell small-3 find-a-hotel-see-all">
            <button onClick={seeAllHotels}>See all hotels</button>
          </div>
          <div className="cell small-3">
            <button onClick={showMapView}>
              {theme && <MapIcon alt={theme.alt} src={theme.src} />}
              Map view
            </button>
          </div>
        </div>
        {isAllShown ? (
          // if show all is triggered
          <SeeAllHotels filtered={filtered} scrollTop={scrollTop} />
        ) : allPlaces.length !== filtered.length && windowWidth > 1024 ? (
          // else if filtering and on large screens

          <FilteringDesktop filtered={filtered} tagged={tagFilter} theme={theme} searchKey={SearchKey} allPlaces={allPlaces} />
        ) : (
          // else dropdown on mobile
          <Search seeAllHotels={seeAllHotels} showMapView={showMapView}  theme={theme} />
        )}
      </div>
    </AppContext.Provider>
  );
}

PanelHotels.propTypes = {
  allPlaces: array.isRequired,
  selectLocation: func,
  theme: object.isRequired,
  hotelsLen: number,
  countriesLen: number
};

export default PanelHotels;
